<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub" v-if="type == 'monthly'"><i class="el-icon-date"></i> Monthly Contract
          History</span>
        <span style="vertical-align: sub" v-else><i class="el-icon-date"></i> Compliance Contract History</span>
      </div>
      <div v-if="historyList && historyList.length > 0">
        <el-tabs v-model="tabActive" tab-position="left" type="border-card" class="contract-history-tabs">
          <el-tab-pane v-for="(item, index) in historyList" :key="index" :name="String(index)">
            <template slot="label">
              <div class="contract-tab-label">
                <div class="contract-tab-label__meta">
                  <i :class="['contract-status-icon', statusIconClass(item.contract_details.status), statusColorClass(item.contract_details.status)]"></i>
                  <b>{{ numberFormat(item.contract_details.total_amount) }} {{ item.contract_details.currency.toUpperCase() }} {{ item.contract_details.duration_months }} months</b>
                  <span class="text-mute-time">
                    {{ dateFormat(item.contract_details.created_at) }}
                  </span>
                </div>

              </div>
            </template>

            <el-descriptions :column="2" border size="medium" class="contract-summary">
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-data-line"></i>
                  Status
                </template>
                <el-tag size="small" :type="statusTagType(item.contract_details.status)">
                  {{ item.contract_details.status.toUpperCase() }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-money"></i>
                  Total
                </template>
                {{ numberFormat(item.contract_details.total_amount) }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-date"></i>
                  Month Agreement
                </template>
                {{ item.contract_details.duration_months }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-coin"></i>
                  Currency
                </template>
                {{ item.contract_details.currency.toUpperCase() }}
              </el-descriptions-item>
            </el-descriptions>
            <div style="margin-top:20px"></div>
            <el-table :data="item.history" border style="width: 100%" height="400">
              <el-table-column prop="transactionDate" label="Date" width="180" align="center">
                <template slot-scope="scope">{{ dateFormat(scope.row.transactionDate) }}</template>
              </el-table-column>
              <el-table-column prop="monthIndex" label="Month" width="80" align="center"></el-table-column>
              <el-table-column prop="description" label="Description"></el-table-column>
              <el-table-column prop="debit" label="Debit" width="120" align="right">
                <template slot-scope="scope">{{ numberFormat(scope.row.debit) }}</template>
              </el-table-column>
              <el-table-column prop="credit" label="Credit" width="120" align="right">
                <template slot-scope="scope">{{ numberFormat(scope.row.credit) }}</template>
              </el-table-column>
              <el-table-column prop="balance" label="Balance" width="120" align="right">
                <template slot-scope="scope">{{ numberFormat(scope.row.balance) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-else v-loading="loading" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
        <span v-if="!loading" style="color: #909399;">No Data</span>
      </div>
    </el-card>
  </div>

</template>

<script>
import { getContractStateHistory } from "@/api/customer";
// import contractHistoryMock from "../../../../docs/AB-208-ABBS-Contract-Support-CreateNew/data.mock.json";
import { currencyFormat, dateFormat } from "@/utils";

export default {
  name: "ContractHistory",
  props: {
    customerUID: String,
    type: String
  },
  data() {
    return {
      loading: false,
      historyList: [],
      tabActive: "0"
    };
  },

  methods: {
    numberFormat(value) {
      return currencyFormat(Number(value), '');
    },
    dateFormat(value) {
      return dateFormat(value, 'DD/MM/YYYY HH:mm:ss');
    },
    statusTagType(status) {
      if (status === 'suspended') return 'danger';
      if (status === 'completed') return '';
      return 'success';
    },
    statusIconClass(status) {
      if (status === 'suspended') return 'el-icon-error';
      if (status === 'completed') return 'el-icon-circle-check';
      return 'el-icon-success';
    },
    statusColorClass(status) {
      if (status === 'suspended') return 'is-danger';
      if (status === 'completed') return 'is-primary';
      return 'is-success';
    },
    getHistory() {
      this.loading = true;
      this.historyList = [];
      // TODO AB-208: mock data for now — swap back to getContractStateHistory(this.customerUID, this.type)
      // Promise.resolve({ result: true, data: contractHistoryMock }).then(({ result, data }) => {
      getContractStateHistory(this.customerUID, this.type).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.historyList = data || [];
          this.tabActive = "0";
        }
      }).catch(() => {
        this.loading = false;
      });
    },

  },
  mounted() {
    this.getHistory();
  }
};
</script>

<style lang="scss" scoped>
.contract-history-tabs {
  ::v-deep .el-tabs__header.is-left {
    width: 220px;
  }

  ::v-deep .el-tabs__nav-wrap.is-left,
  ::v-deep .el-tabs__nav.is-left {
    width: 100%;
  }

  ::v-deep .el-tabs__item.is-left {
    width: 100%;
    box-sizing: border-box;
    height: auto;
    line-height: normal;
    padding: 12px 16px;
    text-align: left;
    white-space: normal;
  }
}

.contract-tab-label {
  &__title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  &__meta {
    color: #909399;
    font-size: 12px;
    margin-top: 4px;
  }
}
.text-mute-time {
  color: #909399;
  font-size: 11px;
}

.contract-status-icon {
  &.is-success {
    color: #67c23a;
  }
  &.is-danger {
    color: #f56c6c;
  }
  &.is-primary {
    color: #409eff;
  }
}
</style>
